import React from 'react'
import SS from './ss.png';

const HowToBuild = () => {
  return (
    <div className='flex flex-col h-screen w-full items-center justify-center'>
      <div>
        <a href='/' className='underline text-blue-600 w-full flex items-center justify-start'>Go Home</a>
      </div>
      <img src={SS} className='flex items-center justify-center' />
    </div>
  )
}

export default HowToBuild;